import { fetchGoaltenderManifests } from '#actions/integrations';
import { useDispatch } from '#hooks/useDispatch';
import { useIntegrationManifests } from '#reducers/integrations';
import { useCurrentEnvironmentEntity } from '#reducers/projects';
import { ready } from '#utils/reduxUtils';

// this could eventually be moved to a utility hook file that draws from multiple reducer files
export function useApprovalServiceManifest() {
  const environment = useCurrentEnvironmentEntity();
  const integrationManifests = useIntegrationManifests();

  // Only fetch the integration manifests if an integration is being used to manage approvals
  const isIntegrationApproval = environment.hasIntegrationApproval();
  const isApprovalManifestReady = isIntegrationApproval ? ready(integrationManifests) : true;

  const dispatch = useDispatch();

  if (!isApprovalManifestReady) {
    // fetchGoaltenderManifests is a thunk creator; call it
    void dispatch(fetchGoaltenderManifests());
  }

  const manifest = integrationManifests.getIn(['manifests', environment.approvalSettings?.serviceKind]);
  return manifest ? manifest.toJS() : undefined;
}
